import React from 'react';
import { getAnalytics } from 'analytics';
import { CommonModalProps } from 'components/CommonModal/context';
import InstantCheckoutModalContent, {
  InstantCheckoutModalContentProps,
} from 'components/InstantCheckoutModalContents/InstantCheckoutModalContent';
import { ModalSeverityValues } from 'constants/modals/modalSeverityValues';

export const getInstantCheckoutModal: (
  options: InstantCheckoutModalContentProps,
) => CommonModalProps = ({ location, regularCheckoutDestination }) => ({
  id: 'instantCheckoutModal',
  severity: ModalSeverityValues.INFO,
  titleText: 'Check out the way you want',
  children: (
    <InstantCheckoutModalContent
      location={location}
      regularCheckoutDestination={regularCheckoutDestination}
    />
  ),
  handleModalClose: () => {
    getAnalytics().trackEvent({
      event: 'instant_checkout_close',
      instant_checkout: {
        location,
      },
    });
  },
});
